import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { StepperStepBlock } from './stepper-step-block.js'
import { assignCommonProperties } from '../../util/data/assign-common-properties.js'
import { Expression } from '../../data/text-or-code.js'

export const StepperOrientations = {
	horizontal: 'Horizontal',
	vertical: 'Vertical',
} as const
export type StepperOrientation = keyof typeof StepperOrientations

export const StepperBindingTypes = {
	value: 'Binding relates to Step value (defined on each Step)',
	index: 'Binding relates to Step index (0-based)',
}
export type StepperBindingType = keyof typeof StepperBindingTypes

@jsonClass('StepperBlock')
export class StepperBlock extends Block {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 2,
		label: 'Binding type',
		options: Object.entries(StepperBindingTypes),
	})
	stepperBindingType: StepperBindingType = 'value'

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Binding',
		codeLanguage: 'ts',
		tsReturnType: () => 'string | number',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => false,
	})
	bindingCode = new Expression()

	@ScreenEditorInput<StepperBlock>({
		inputType: 'code',
		order: 3,
		label: 'Orientation',
		codeLanguage: 'ts',
		tsReturnType: () => `'horizontal' | 'vertical'`,
		editorSize: 'singleline',
		isBinding: false,
	})
	@jsonProperty(String)
	orientationCode: string = "'horizontal'"

	@ScreenEditorInput<StepperBlock>({
		inputType: 'code',
		order: 4,
		label: 'Linear',
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: false,
	})
	@jsonProperty(String)
	isLinearCode: string = 'false'

	constructor(init: Partial<StepperBlock> = {}) {
		super()
		assignCommonProperties(this, init)
	}

	static createNewForEditor() {
		return new this({
			children: [StepperStepBlock.createNewForEditor()],
		})
	}

	getPreviewDirection(): 'row' | 'column' {
		return 'column'
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#b0bec5'
	}

	getTitleColor(): string {
		return '#263238'
	}

	getEditorCategory(): string {
		return 'Additional Form Fields'
	}
}
